// https://github.com/AsyncBanana/microdiff

import * as _ from 'lodash';
import { PROJECT_COMPARE_PROPERTIES } from 'src/consts';
import { IProject } from "src/models";

declare const md5: any;

export default {
    /* private */ diffSync(value: any, newValue: any): boolean {
        value = this.setEmptyPropertyToNull(value);
        newValue = this.setEmptyPropertyToNull(newValue);
        return md5(JSON.stringify(value)) !== md5(JSON.stringify(newValue));
    },

    // 将空属性置为null
    /* private */ setEmptyPropertyToNull(value: any): any {
        return _.mapValues(value, item => item || null);
    },

    // 项目筛选出需要比较的属性
    /* private */ takeProjectComparePropertiesSync(project: IProject): IProject {
        project = _.pick(project, PROJECT_COMPARE_PROPERTIES) as IProject;
        project.other_person_liable_accounts = project.other_person_liable_accounts || [];
        // project.other_person_liable_accounts = _.sortBy(project.other_person_liable_accounts);
        return project;
    },

    // 项目列表筛选出需要比较的属性
    /* private */ takeProjectsComparePropertiesSync(projects: IProject[]): IProject[] {
        return _.map(projects, project => {
            return this.takeProjectComparePropertiesSync(project);
        });
    },

    // 比较原始项目列表、实时项目列表，得到变化的项目列表
    getDirtyProjectsSync(
        originalProjects: IProject[],   // 原始项目列表
        projects: IProject[]    // 实时项目列表
    ): IProject[] {
        // 原始项目列表筛选出需要比较的属性
        const _originalProjects = this.takeProjectsComparePropertiesSync(originalProjects);

        // 实时项目列表筛选出需要比较的属性
        const _projects = this.takeProjectsComparePropertiesSync(projects);

        const dirtyProjects: IProject[] = [];
        _.forEach(_projects, (_project, index) => {
            const _originalProject = _.find(_originalProjects, { puid: _project.puid });
            // 记录新增的项目
            if (!_originalProject) {
                dirtyProjects.push(projects[index]);
                return;
            }
            // 记录变更的项目
            const isDirty = this.diffSync(_originalProject, _project);
            if (isDirty) {
                dirtyProjects.push(projects[index]);
            }
        });
        return dirtyProjects;
    },

    // 比较项目列表是否变化
    getIsProjectsDirty(xProjects: IProject[], yProjects: IProject[]) {
        return this.diffSync(this.takeProjectsComparePropertiesSync(xProjects), this.takeProjectsComparePropertiesSync(yProjects));
    }
}